import { render, staticRenderFns } from "./shareGuide.vue?vue&type=template&id=f77f78c4&scoped=true"
import script from "./shareGuide.vue?vue&type=script&lang=js"
export * from "./shareGuide.vue?vue&type=script&lang=js"
import style0 from "./shareGuide.vue?vue&type=style&index=0&id=f77f78c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77f78c4",
  null
  
)

export default component.exports